import React, { useState } from 'react';
import { Popover, PopoverBody } from 'reactstrap';

import { Availability } from '~weekly-planner/lib/common';

interface ComponentProps {
  availability: Availability | Availability[] | null;
  id: string;
}
export const AvailabilityHeader: React.FC<ComponentProps> = ({ availability, id }) => {
  const [popoverOpen, setPopoverOpen] = useState(false);

  if (!availability) return <></>;
  if (Array.isArray(availability)) {
    return (
      <div className="availability-item">
        <Popover
          placement="top"
          isOpen={popoverOpen}
          target={`availability-group-${id}`}
          toggle={() => setPopoverOpen(!popoverOpen)}
        >
          <PopoverBody>
            {availability.map((avail, index) => (
              <div key={index} className="availability-popover">
                {avail.start} - {avail.end}
              </div>
            ))}
          </PopoverBody>
        </Popover>
        <div
          id={`availability-group-${id}`}
          className="availability-item"
          onClick={() => setPopoverOpen(true)}
          onMouseLeave={() => setPopoverOpen(false)}
        >
          <div className="availability-split">Split Availablity</div>
        </div>
      </div>
    );
  }
  return (
    <div className="availability-item">
      <div
        id={`availability-single-${id}`}
        className="availability-item"
        onMouseEnter={() => setPopoverOpen(true)}
        onMouseLeave={() => setPopoverOpen(false)}
      >
        {availability.start} - {availability.end}
      </div>
    </div>
  );
};

export default AvailabilityHeader;
